import { Checkbox, FormLabel , FormControlLabel , FormControl, Stack } from '@mui/material';


import { RHFTextField } from 'src/components/hook-form';
// ----------------------------------------------------------------------

export default function DetailsSection({
  isFree,
  setIsFree,
  isDocument,
}: {
  isFree: boolean;
  isDocument?: boolean;
  setIsFree(value: boolean): void;
}) {
  return (
    <>
      <Stack direction={'row'} spacing={1}>
        <RHFTextField name="title" label="English Item title" />
        <RHFTextField name="title_ar" label="Arabic Item title" />
      </Stack>
      <Stack direction={'row'} spacing={3}>
        {/* <RHFTextField type={'number'} name="points" label="Item Point" sx={{ width: '50%' }} /> */}
        {!isDocument && (
          <RHFTextField
            type={'number'}
            name="duration"
            label="Item Duration In Minutes"
            sx={{ width: '50%' }}
          />
        )}
        <FormControl>
          <FormLabel id="">Is Free To Watch</FormLabel>
          <FormControlLabel
            checked={isFree}
            onChange={(e: any) => {
              setIsFree(!isFree);
            }}
            label="Is Free"
            control={<Checkbox />}
          />
        </FormControl>
      </Stack>

      <RHFTextField multiline minRows={2} name="description" maxRows={3} label="English Item Description" />
      <RHFTextField multiline minRows={2} name="description_ar" maxRows={3} label="Arabic Item Description" />
    </>
  );
}
